import { render, staticRenderFns } from "./ModalBanner.vue?vue&type=template&id=b3ccdd5a&scoped=true&"
import script from "./ModalBanner.vue?vue&type=script&lang=js&"
export * from "./ModalBanner.vue?vue&type=script&lang=js&"
import style0 from "./ModalBanner.vue?vue&type=style&index=0&id=b3ccdd5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ccdd5a",
  null
  
)

export default component.exports